import {
  ExternalNavLink,
  NavigationContainer,
  NavLink,
} from './styles/Navigation'
import {
  getVisibleTabs,
  NavigationContext,
  NavigationTab,
} from './ContextualNavigation'

interface Props {
  context: NavigationContext | null
  isInternalUser: boolean
  pathname: string
  insightsURL?: string
  getRmsCampaignURL: () => string
  getRmsBillingURL: () => string
  getPlanningURL: () => string
}

const Navigation = ({
  context,
  isInternalUser,
  pathname,
  insightsURL,
  getRmsCampaignURL,
  getRmsBillingURL,
  getPlanningURL,
}: Props) => {
  // Get visible tabs based on context and user type
  const visibleTabs = getVisibleTabs(context, isInternalUser)

  // Helper to render tab based on tab name
  const renderTab = (tab: NavigationTab) => {
    switch (tab) {
      case 'Campaigns':
        return (
          <ExternalNavLink
            key={tab}
            href={getRmsCampaignURL()}
            rel="noopener noreferrer"
          >
            Campaigns
          </ExternalNavLink>
        )
      case 'Reports':
        // Reports is always active - it's the current application
        return (
          <NavLink key={tab} to={'/'}>
            Reports
          </NavLink>
        )
      case 'Billing':
        return (
          <ExternalNavLink
            key={tab}
            href={getRmsBillingURL()}
            rel="noopener noreferrer"
          >
            Billing
          </ExternalNavLink>
        )
      case 'Planning':
        return (
          <ExternalNavLink
            key={tab}
            href={getPlanningURL()}
            rel="noopener noreferrer"
          >
            Planning
          </ExternalNavLink>
        )
      case 'Insights':
        return insightsURL ? (
          <ExternalNavLink key={tab} href={insightsURL}>
            Insights
          </ExternalNavLink>
        ) : null
      default:
        return null
    }
  }

  return (
    <NavigationContainer>
      {visibleTabs.map((tab) => renderTab(tab))}
    </NavigationContainer>
  )
}

export default Navigation
